
import { RunListActions, RunListModuleState } from '@/store/run/list'
import { defineComponent, PropType } from 'vue'
import { mapActions, mapState } from 'vuex'
import { Run } from '~/types/types'
import { resolveNodes } from '~/utils/array'
import { GeneralizedRunT, generalizeRun } from '~/utils/runs'
import BranchList from '../BranchList.vue'

export default defineComponent({
  name: 'RunBranches',
  components: {
    BranchList
  },
  props: {
    isExpanded: {
      type: Boolean,
      default: false
    },
    generalizedRun: {
      type: Object as PropType<GeneralizedRunT>,
      required: true
    },
    branchRunCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      listLoading: false
    }
  },
  computed: {
    ...mapState('run/list', {
      branchRunList: (state: any) => state.branchRunList as RunListModuleState['branchRunList']
    }),
    runsInBranch(): Array<Run> {
      if (this.generalizedRun.branchName) {
        const runList = this.branchRunList[this.generalizedRun.branchName] || []
        const branchRuns = resolveNodes(runList)

        return branchRuns.filter((run) => run.runId !== this.generalizedRun.runId)
      }
      return []
    },
    count(): number {
      return (this.generalizedRun.runCount || this.branchRunCount) - 1
    }
  },
  methods: {
    ...mapActions('run/list', {
      fetchBranchRuns: RunListActions.FETCH_BRANCH_RUNS_LIST
    }),
    generalizeRun,
    async toggled(isExpanded: boolean): Promise<void> {
      if (isExpanded) {
        await this.fetchRuns()
        this.$emit('expanded', this.generalizedRun.branchName)
      } else this.$emit('expanded', '')
    },
    async fetchRuns(): Promise<void> {
      this.listLoading = true
      await this.fetchBranchRuns({
        provider: this.$route.params.provider,
        owner: this.$route.params.owner,
        name: this.$route.params.repo,
        branchName: this.generalizedRun.branchName || ''
      }).then(() => {
        this.listLoading = false
      })
    }
  }
})
